import { createContext } from 'react';

const StatusBadgeInfoContext = createContext(false);

export default StatusBadgeInfoContext;
